
// download global API
export const download_files = (downloadFiles) => {
    try {
        let promises = downloadFiles.map((file) => fetch(`/api/v1/fetch/download/${file.backendId}/${file.path.replace(/\//g, "%2F")}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        }))
        Promise.all(promises).then((responses) => {
            responses.map((data) => {
                if (data.ok) {
                    window.open(data.headers.get('location'), '_blank');
                }
            })
        })
    } catch (error) {
        console.error(error.message);
    }
}

// download meta file API
export const download_meta_file = async (backEndId, metaFile) => {
    try {
        fetch('/api/v1/annotation/download_meta/' + backEndId + "/" + metaFile, {
            method: 'GET',
        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');

                // Get filename from Content-Disposition header
                const disposition = response.headers.get('content-disposition');
                let filename = metaFile.replace('\/', '_').split('.mp4')[0] + '.json'; // Default name if header is missing

                if (disposition && disposition.includes('filename=')) {
                    filename = disposition
                        .split('filename=')[1]
                        .split(';')[0]
                        .replace(/"/g, '');
                }
                return response.blob().then(blob => ({ blob, filename }));
            })
            .then(({ blob, filename }) => {
                // Create a link element and trigger a download
                const link = document.createElement('a');
                const downloadUrl = URL.createObjectURL(blob);
                link.href = downloadUrl;
                link.download = filename;
                document.body.appendChild(link);
                link.click();

                // Clean up
                link.remove();
                URL.revokeObjectURL(downloadUrl);
            })
            .catch(error => console.error('File download failed:', error));
    } catch (error) {
        console.error(error.message);
    }
}


// export const download_video_frames = async (backend_id, file_path, roi_id = -1, x, y, width, height, frame_interval) => {
//     try {
//         const url = `/api/v1/frames/download/${backend_id}/${file_path.replace(/\//g, "%2F")}?roi_id=${roi_id != -1 ? roi_id : -1}&x=${roi_id != -1 ? x : 0}&y=${roi_id != -1 ? y : 0}&width=${roi_id != -1 ? width : 0}&height=${roi_id != -1 ? height : -1}&frame_interval=${roi_id != -1 ? frame_interval : -1}`;

//         // Fetch the file
//         const response = await fetch(url, {
//             method: "GET",
//         });

//         if (!response.ok) {
//             throw new Error("Failed to download file");
//         }
//         let fileName = file_path.replace('\/', '_').split('.mp4')[0] + `${roi_id != -1 ? "_roi_" + roi_id : ''}` + '.zip'; // Default name if header is missing


//         const blob = await response.blob();
//         if (blob.size === 0) {
//             throw new Error("Empty file received from the server");
//         }

//         // Create a URL for the Blob
//         const blobUrl = window.URL.createObjectURL(blob);

//         // Create an anchor element and trigger the download
//         const link = document.createElement("a");
//         link.href = blobUrl;
//         link.setAttribute("download", `${fileName || "download"}.zip`);
//         document.body.appendChild(link);
//         link.click();

//         // Cleanup
//         link.remove();
//         window.URL.revokeObjectURL(blobUrl);
//     } catch (error) {
//         console.error(error.message);
//     }
// }


export const download_video_frames = async (
  backend_id, file_path, roi_id = -1, x, y, width, height, frame_interval, 
  setProgress = () => {},
  setStatus = () => {}
) => {
  try {
    const url = `/api/v1/frames/download/${backend_id}/${file_path.replace(/\//g, "%2F")}?roi_id=${roi_id}&x=${x}&y=${y}&width=${width}&height=${height}&frame_interval=${frame_interval}`;
    
    const jobInitRes = await fetch(url);
    if (!jobInitRes.ok) throw new Error("Failed to start download job");

    const { job_id } = await jobInitRes.json();
    if (!job_id) throw new Error("Invalid job ID");

    console.log(`📦 Job started: ${job_id}`);

    const pollUrl = `/api/v1/server_jobs/${job_id}`;
    const pollInterval = 1000;
    const maxAttempts = 300;
    let attempts = 0;

    while (attempts++ < maxAttempts) {
      const statusRes = await fetch(pollUrl);
      const status = await statusRes.json();

      setProgress(status.progress || 0);
      setStatus(status.status_message || "Processing...");

      if (status.status === "complete") {
        console.log("✅ Job completed. Downloading...");
        window.location.href = `${pollUrl}?result=true`;
        return;
      } else if (status.status === "error") {
        throw new Error(`Job failed: ${status.error}`);
      }

      console.log(`Progress: ${status.progress}%`);
      await new Promise(res => setTimeout(res, pollInterval));
    }

    throw new Error("❌ Download job timed out");
  } catch (error) {
    console.error(error.message);
  }
};


export const updateAccessKey = async (labelvalue_id, updatePayload) => {
    try {
        const authToken = localStorage.getItem('authToken');
        const response = await fetch(`/api/v1/labelset/labelvalue/update/${labelvalue_id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify(updatePayload),
        });

        const data = await response.json();

        if (response.status === 401) {
            window.location.href = '/login';
            throw new Error('UnAuthorized. Please login');
        } else if (!response.ok) {
            throw new Error(data.detail || 'Failed to update label value');
        }

        return data;
    } catch (error) {
        throw new Error(error.message || 'Unknown error occurred');
    }
};


export const updateAllAccessKeys = async (labelset_id, updatePayloadList) => {
    try {
        const authToken = localStorage.getItem('authToken');
        const response = await fetch(`/api/v1/labelset/labelvalue/update-all/${labelset_id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify(updatePayloadList),
        });

        const data = await response.json();

        if (response.status === 401) {
            window.location.href = '/login';
            throw new Error('UnAuthorized. Please login');
        } else if (!response.ok) {
            throw new Error(data.detail || 'Failed to update label values');
        }

        return data;
    } catch (error) {
        throw new Error(error.message || 'Unknown error occurred');
    }
};


// explorer API
export const delete_backend_connection = async (backendid) => {
    const url = `/api/v1/backends/delete/${backendid}`;
    try {
        const response = await fetch(url, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}

export const add_roi_coordinate = async (collectionID, reqPayload) => {
    const url = `/api/v1/roi/create/${collectionID}`;
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqPayload)
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}

export const get_roi_coordinate = async (collectionID) => {
    const url = `/api/v1/roi/${collectionID}`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}

export const update_roi_coordinate = async (collection_Id, roi_id, reqPayload,label) => {
    const url = `/api/v1/roi/update/${collection_Id}/${roi_id}?label=${label}`;
    try {
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqPayload)
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error.message);
    }
}


export const delete_roi_coordinate = async (collection_Id, roi_id) => {
    const url = `/api/v1/roi/delete/${collection_Id}/${roi_id}`;
    try {
        const response = await fetch(url, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error.message);
    }
}


export const createNewCollection = async (reqPayload) => {
    try {
        const response = await fetch('/api/v1/collection/create', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqPayload)
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error.message);
    }
}

export const remove_items_from_collection = async (collectionId, req_payload) => {
    try{
        const response = await fetch(`/api/v1/collection/remove/${collectionId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(req_payload),
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error.message);
    }
}


export const createNewTag = async (reqPayload) => {
    try {
        const response = await fetch('/api/v1/tags/create', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqPayload)
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error.message);
    }
}

export const get_tag_list_of_mapped_videos = async (tagId) => {
    const url = `/api/v1/tags/${tagId}`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }

        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }

}

export const get_tags_list = async () => {
    const url = `/api/v1/tags/`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }

        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }

}

export const get_mapped_tags_list = async (filePath) => {
    const url = `/api/v1/tags/tags_for_file/${filePath.replace(/\//g, "%2F")}`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }

        const data = await response.json();
        return data
    } catch (error) {
        throw new Error(`Response status: ${error}`);
    }
}


export const deleteTag = async (tagID) => {
    try {
        const response = await fetch(`/api/v1/tags/delete/${tagID}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error.message);
    }
}


export const add_tags_to_video = async (tagId, reqpayload) => {
    const url = `/api/v1/tags/add/${tagId}`;
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqpayload)
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}


export const remove_tags_from_video = async (tagId, reqpayload) => {
    const url = `/api/v1/tags/remove/${tagId}`;
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqpayload)
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }

        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }

}


export const create_new_folder = async (backEndId, reqPayload) => {
    try {
        const response = await fetch('/api/v1/file_ops/create_dir/' + backEndId, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqPayload)
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error.message);
    }
}

export const delete_files_from_folder = async (backEndId, reqPayload) => {
    try {
        const response = await fetch('/api/v1/file_ops/delete/' + backEndId, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqPayload)
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error.message);
    }
}


export const upload_files = async (backendId, uploadPath, formData) => {
    try {
        const response = await fetch('/api/v1/file_ops/upload/' + backendId + '/' + uploadPath.replace(/\//g, "%2F"), {
            method: 'POST',
            body: formData,
        });

        if (response.ok) {
            return `${formData.length == 1 ? 'File' : 'Files'} uploaded successfully!`;
        } else {
            throw new Error(`${formData.length == 1 ? 'File' : 'Files'} upload failed.`);
        }
    } catch (error) {
        throw new Error(`Error uploading the ${formData.length == 1 ? 'File' : 'Files'}`);
    }
};


// content collection view

export const get_all_collections = async () => {
    const url = `/api/v1/collection`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }

        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}

export const get_mapped_collections_list = async (filePath) => {
    const url = `/api/v1/collection/collections_for_file/${filePath.replace(/\//g, "%2F")}`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }

        const data = await response.json();
        return data
    } catch (error) {
        throw new Error(`Response status: ${error}`);
    }
}

export const add_videos_to_collection = async (collectionId, reqPayload) => {
    try {
        const response = await fetch('/api/v1/collection/add/' + collectionId, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqPayload)
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error.message);
    }
}

export const delete_collection = async (collection_Id) => {
    try {
        const response = await fetch('/api/v1/collection/delete/' + collection_Id, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error.message);
    }
}



export const get_collections_labelList = async (collectionId) => {
    const url = `/api/v1/collection/${collectionId}/labelsets/`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }

        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }

}

export const delete_labelset_label = async (labelId) => {
    const url = `/api/v1/labelset/labelvalue/delete/${labelId}`;
    try {
        const response = await fetch(url, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }

        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }

}

export const get_labelsList = async () => {
    try {
        const response = await fetch(`api/v1/labelset/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        }
        );
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}

export const exportToCVATTool = async (requestData) => {
    try {
        const response = await fetch(`/api/v1/cvat/export_collection/${requestData.collectionId}?username=${requestData.username}&password=${requestData.password}&task_name=${requestData.taskName}&segments=${requestData.segments}${requestData?.host != '' ? '&host=' + requestData?.host : ''}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (response.status!=200) {
            throw new Error(`Response status: ${response.status}`);
        }
        return response;
    } catch (error) {
        console.error(error.message);
    }
}

export const getlabelSublabelsList = async (sublabel) => {
    try {
        const response = await fetch(`/api/v1/labelset/${sublabel.id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        }
        );
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error.message);
    }
}

export const createnewLabel = async (reqPayload) => {
    try {
        const response = await fetch(`/api/v1/labelset/create`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqPayload)
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error.message);
    }
}

export const addLabeltoCollection = async (collectionId, reqPayload) => {
    try {
        const response = await fetch(`/api/v1/collection/addLabelSet/${collectionId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqPayload)
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error.message);
    }
}

export const removeLabelfromCollection = async (collectionId, reqPayload) => {
    try {
        const response = await fetch(`/api/v1/collection/removeLabelSet/${collectionId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqPayload)
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error.message);
    }
}

export const deleteLabel = async (labelId) => {
    try {
        const response = await fetch(`/api/v1/labelset/delete/${labelId}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`This Label Cannot be Deleted because it's been used in another collection.`)
    }
}

export const updateLabelSublabels = async (labelId, reqPayload) => {
    try {
        const response = await fetch(`/api/v1/labelset/update/${labelId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqPayload)
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error.message);
    }
}


//-------------------------------- Login Page --------------------------------

export const loginUser = async (reqData) => {
    try {
        const response = await fetch('/api/v1/users/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(reqData),
        });

        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.detail);
        }else if(data?.status!="success"){
            throw new Error(response.message);
        }
        return data;
    } catch (error) {
        throw new Error(error);
    }
};

export const createUser = async(req) =>{
    try {
        const authToken =localStorage.getItem('authToken');
        const response = await fetch('/api/v1/users/create-user', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify(req),
        });

        const data = await response.json();
        if (response.status==401) {
            window.location.href='/login';
            throw new Error(`UnAuthorized Please login`);
        }
        else if (!response.ok) {
            throw new Error(data.detail);
        }else if(data?.status!="success"){
            throw new Error(response.message);
        }
        return data;
    } catch (error) {
        throw new Error(error);
    }
}

export const changePassword = async(req) => {
    try {
        const authToken =localStorage.getItem('authToken');
        const response = await fetch('/api/v1/users/update-password', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify(req),
        });
        const data = await response.json();
        if (response.status==401) {
            window.location.href='/login';
            throw new Error(`UnAuthorized Please login`);
        }
        else if (!response.ok) {
            throw new Error(data.detail);
        }else if(data?.status!="success"){
            throw new Error(response.message);
        }
        return data;
    } catch (error) {
        throw new Error(error);
    }
}


export const updateUser =async(req)=>{
    try {
        const authToken =localStorage.getItem('authToken');
        const response = await fetch('/api/v1/users/update-user', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify(req),
        });

        const data = await response.json();
        if (response.status==401) {
            window.location.href='/login';
            throw new Error(`UnAuthorized Please login`);
        }
        else if (!response.ok) {
            throw new Error(data.detail);
        }else if(data?.status!="success"){
            throw new Error(response.message);
        }
        return data;
    } catch (error) {
        throw new Error(error);
    }
}

export const forgotPassword =async(email)=>{
    try {
        const response = await fetch('/api/v1/users/forgot-password/'+email.replace(/\@/g, "%40"), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.detail);
        }else if(data?.status!="success"){
            throw new Error(response.message);
        }
        return data;
    } catch (error) {
        throw new Error(error);
    }
}



export const validateOTP =async(req)=>{
    try {
        const authToken =localStorage.getItem('authToken');
        const response = await fetch('/api/v1/users/validate-otp', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify(req),
        });
        const data = await response.json();
        if (response.status==401) {
            window.location.href='/login';
            throw new Error(`UnAuthorized Please login`);
        }
        else if (!response.ok) {
            throw new Error(data.detail);
        }else if(data?.status!="success"){
            throw new Error(response.message);
        }
        return data;
    } catch (error) {
        throw new Error(error);
    }
}


export const deleteUser =async(username)=>{
    try {
        const authToken =localStorage.getItem('authToken');
        const response = await fetch('/api/v1/users/delete/'+username, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            }
        });

        const data = await response.json();
        if (response.status==401) {
            window.location.href='/login';
            throw new Error(`UnAuthorized Please login`);
        }
        else if (!response.ok) {
            throw new Error(data.detail);
        }else if(data?.status!="success"){
            throw new Error(response.message);
        }
        return data;
    } catch (error) {
        throw new Error(error);
    }
}




export const getAllUsers =async()=>{
    try {
        const authToken =localStorage.getItem('authToken');
        const response = await fetch('/api/v1/users/user-data', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            }
        });
        const data = await response.json();
        if (response.status==401) {
            window.location.href='/login';
            throw new Error(`UnAuthorized Please login`);
        }
        else if (!response.ok) {
            throw new Error(data.detail);
        }else if(data?.status!="success"){
            throw new Error(response.message);
        }

        return data;
    } catch (error) {
        throw new Error(error);
    }
}


export const getUserPermissions = async() =>{
    try{
        const response = await fetch('/api/v1/userpermission', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.detail);
        }else if(data?.status!="success"){
            throw new Error(response.message);
        }
        return data;
    } catch (error) {
        throw new Error(error);
    }
}


//-------------------------------- File Annotator Page --------------------------------
export const getCollectionFileList =async(collectionId)=>{
    try {
        const response = await fetch('/api/v1/fileannotation/search/'+collectionId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.detail);
        }else if(response?.status!=200){
            throw new Error(response.message);
        }
        return data;
    } catch (error) {
        throw new Error(error);
    }
}


export const getCollectionSchema =async(collectionId)=>{
    try {
        const response = await fetch('/api/v1/fileannotation/get-schemas?collection_id='+collectionId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        let data=response;
        if (!response.ok) {
            throw new Error(`Error fetching text file: ${response.statusText}`);
        }else if(response?.status!=200){
            throw new Error(response.message);
        }
        return data.json();
    } catch (error) {
        throw new Error(error);
    }
}


export const addSchemaToCollection =async(max_schema_size,reqData)=>{
    try {
        const authToken =localStorage.getItem('authToken');
        const response = await fetch('/api/v1/fileannotation/create-schemas?max_schema_size='+max_schema_size, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify(reqData)
        });
        let data=response;
        if (response.status==401) {
            window.location.href='/login';
            throw new Error(`UnAuthorized Please login`);
        }
        else if (data.status=='failure') {
            throw new Error(`${data.detail}`);
        }
        else if (!response.ok) {
            throw new Error(`Error fetching text file: ${response?.detail}`);
        }else if(response?.status!=200){
            throw new Error(response.message);
        }
        return data.json();
    } catch (error) {
        throw new Error(error);
    }
}

export const updateSchema =async(reqData)=>{
    try {
        const authToken =localStorage.getItem('authToken');
        const response = await fetch('/api/v1/fileannotation/update-schema?schema_id='+reqData?.schema_id+'&collection_id='+reqData?.collection_id, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify(reqData)
        });
        let data=response;
        if (response.status==401) {
            window.location.href='/login';
            throw new Error(`UnAuthorized Please login`);
        }
        else if (!response.ok) {
            throw new Error(`Error fetching text file: ${response?.detail}`);
        }else if(response?.status!=200){
            throw new Error(response.message);
        }
        return data.json();
    } catch (error) {
        throw new Error(error);
    }
}


export const getAnnotationFile = async (backendId,collectionId, filePath) => {
    try {
        const response = await fetch(`/api/v1/fileannotation/get-file/${backendId}/${collectionId}/${filePath}`, {
            method: 'GET'
        });
        if (!response.ok) {
            // Handle non-2xx responses
            throw new Error(`Error fetching file: ${response.statusText}`);
        }
            // Check for the content type of the file and handle accordingly
            const contentType = response.headers.get('Content-Type');
            if (contentType.includes("application/pdf")) {
                const blob = await response.blob();
                return blob;  // Handle the PDF file
            } else if (contentType.includes("text/plain")) {
                const text = await response.text();
                return text;  // Handle the text content
            } else if (contentType.includes("application/json")) {
                const json = await response.json();
                return json;  // Handle JSON response
            } else {
                throw new Error("Unsupported file type");
            }
    } catch (error) {
        throw new Error(error.message || "An error occurred while fetching the file");
    }
};



export const updateFileAnnotation =async(reqData)=>{
    try {
        const authToken =localStorage.getItem('authToken');
        const response = await fetch('/api/v1/fileannotation/save-annotation', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify(reqData)
        });
        let data=response;
        if (response.status==401) {
            window.location.href='/login';
            throw new Error(`UnAuthorized Please login`);
        }
        else if (!response.ok) {
            throw new Error(`Error fetching text file: ${response?.detail}`);
        }else if(response?.status!=200){
            throw new Error(response.message);
        }
        return data.json();
    } catch (error) {
        throw new Error(error);
    }
}


export const downloadCollectionSchemas = async (collectionId) => {
    try {
        const url = `/api/v1/fileannotation/download-schema?collection_id=${collectionId}`;

        // Fetch the file
        const response = await fetch(url, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error("Failed to download file");
        }

        const blob = await response.blob();
        if (blob.size === 0) {
            throw new Error("Empty file received from the server");
        }

        // Create a URL for the Blob
        const blobUrl = window.URL.createObjectURL(blob);

        // Create an anchor element and trigger the download
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", `${collectionId}.zip`);
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        console.error(error.message);
    }
}


//-------------------------------- Agents Tab --------------------------------

export const getAgents = async () => {
    const url = `/api/v1/agents/`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}


export const getTasksList = async (agent_id) => {
    const url = `/api/v1/tasks/${agent_id}`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}


export const createTask = async (reqData) => {
    const url = `/api/v1/tasks/create`;
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqData),
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}


export const updateTask = async (taskId,reqData) => {
    const url = `/api/v1/tasks/update/${taskId}`;
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqData),
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}




export const deleteTask = async (taskId) => {
    const url = `/api/v1/tasks/delete/${taskId}`;
    try {
        const response = await fetch(url, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}






export const assignTask = async (agent_id,reqData) => {
    const url = `/api/v1/agents/${agent_id}/assignJob`;
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqData),
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}



export const getAgentDetail = async (agent_id) => {
    const url = `/api/v1/agents/${agent_id}`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}






export const updateUserRequest = async (job_id,reqData) => {
    const url = `/api/v1/jobs/update/${job_id}`;
    try {
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqData),
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}




// -------------------------------- Datasets Tab --------------------------------

export const getDatasetList = async () => {
    const url = `/api/v1/datasets/`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}


export const getDatasetDetail = async (dataset_id) => {
    const url = `/api/v1/datasets/${dataset_id}`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}

export const downloadDataset = async (dataset_id) => {
    const url = `/api/v1/datasets/download/${dataset_id}`;

    try {
        const response = await fetch(url, { method: "GET" });

        if (!response.ok) {
            throw new Error("Failed to download file");
        }

        const blob = await response.blob();
        if (blob.size === 0) {
            throw new Error("Empty file received from the server");
        }

        // Default fallback filename
        let filename = "downloaded_file.zip"; // Default filename
        const contentDisposition = response.headers.get("Content-Disposition");
        if (contentDisposition) {
            const match = contentDisposition.match(/filename="?(.+?)"?$/);
            if (match && match[1]) {
                filename = match[1];
            }
        }

        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        console.error(error.message);
    }
};

export const createDataset=async(jsonData)=> {
    try {
        // Convert JSON data into FormData
        const formData = new FormData();
        for (const key in jsonData) {
            if (key === "file") {
                formData.append(key, jsonData[key]); // File should be appended directly
            } else if (typeof jsonData[key] === "object") {
                formData.append(key, JSON.stringify(jsonData[key])); // Convert objects to JSON string
            } else {
                formData.append(key, jsonData[key]); // Append other values directly
            }
        }
        const userName = localStorage.getItem("username");
        formData.append("created_by", userName);

        const response = await fetch("/api/v1/datasets/create", {
            method: "POST",
            body: formData, // Send FormData
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }

        const result = await response.json();
        console.log("Dataset Created Successfully:", result);
        return result;
    } catch (error) {
        console.error("Failed to create dataset:", error);
        return { error: error.message };
    }
}







export const getModelList = async () => {
    const url = `/api/v1/models/`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}


export const getModelDetail = async (model_id) => {
    const url = `/api/v1/models/model_id?model_id=${model_id}`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error(error.message);
    }
}

export const downloadModel = async (model_id) => {
    const url = `/api/v1/models/download?model_id=${model_id}`;

    try {
        const response = await fetch(url, { method: "GET" });

        if (!response.ok) {
            throw new Error("Failed to download file");
        }

        const blob = await response.blob();
        if (blob.size === 0) {
            throw new Error("Empty file received from the server");
        }

        // Extract filename from response headers
        let filename = "downloaded_model.zip"; // Default filename
        const contentDisposition = response.headers.get("Content-Disposition");
        if (contentDisposition) {
            const match = contentDisposition.match(/filename="?(.+?)"?$/);
            if (match && match[1]) {
                filename = match[1];
            }
        }

        // Create a URL for the Blob
        const blobUrl = window.URL.createObjectURL(blob);

        // Create an anchor element and trigger the download
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        console.error(error.message);
    }
};


export const createModel = async (jsonData) => {
    try {
        // Convert JSON data into FormData
        const formData = new FormData();
        for (const key in jsonData) {
            if (key === "file") {
                formData.append(key, jsonData[key]); // Append file directly
            } else if (typeof jsonData[key] === "object") {
                formData.append(key, JSON.stringify(jsonData[key])); // Convert objects to JSON string
            } else {
                formData.append(key, jsonData[key]); // Append other values directly
            }
        }
        const userName = localStorage.getItem("username");
        formData.append("created_by", userName);

        const response = await fetch("/api/v1/models/create", {
            method: "POST",
            body: formData, // Send FormData
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }

        const result = await response.json();
        console.log("Model Created Successfully:", result);
        return result;
    } catch (error) {
        console.error("Failed to create model:", error);
        return { error: error.message };
    }
};
